<a [class]="classList" [title]="title" (click)="routeTo()" href="javascript:void(0)">
    <i *ngIf="iconClass" [class]="iconClass" aria-hidden="true"></i>
    {{text}}
</a>
